import {gql} from "@apollo/client";

import {GENERIC_MUTATION_RESPONSE_FIELDS} from "@/lib/queries/common.ts";

export enum AnalyzerTurnType {
  INITIAL = "INITIAL",
  INTERVIEW_ANSWER = "INTERVIEW_ANSWER",
  REVISE = "REVISE",
  RETRY = "RETRY",
}

export enum AnalyzerTurnEnd {
  DONE = "DONE",
  ERROR = "ERROR",
  CONNECTION_LOST = "CONNECTION_LOST",
  ABORTED = "ABORTED",
}

// Name buttons as {page}_{placement} so a second button on the same page stays distinguishable.
// Values end up in stored run rows: never rename a released value, only add new ones (no migration needed)
export enum AnalyzerSource {
  ONBOARDING = "onboarding",
  CHECKS_LIST_ACTION_BAR = "checks_list_action_bar",
  CHECKS_LIST_EMPTY_TABLE = "checks_list_empty_table",
  DASHBOARD_CHECKS_ACTION_BAR = "dashboard_checks_action_bar",
  ALERTS_EMPTY_TABLE = "alerts_empty_table",
  DIRECT = "direct",
}

// USD per million tokens
export interface AnalyzerTokenPricing {
  input: number;
  output: number;
  cache_read?: number;
  cache_write?: number;
}

export interface AnalyzerTokenUsageInput {
  input_tokens: number;
  output_tokens: number;
  cache_read_tokens?: number;
  cache_write_tokens?: number;
  pricing?: AnalyzerTokenPricing;
}

export interface AnalyzerRunStartInput {
  thread_id: string;
  url: string;
  source?: AnalyzerSource;
}

export interface AnalyzerRunTurnInput {
  thread_id: string;
  turn_index: number;
  turn_type: AnalyzerTurnType;
  turn_end: AnalyzerTurnEnd;
  error_code?: string;
  revision_success?: boolean;
  usage?: AnalyzerTokenUsageInput;
  elapsed_seconds?: number;
  proposals_count?: number;
}

export interface AnalyzerRunFailureInput {
  url: string;
  source?: AnalyzerSource;
  error_code?: string;
}

export const GQL_RECORD_ANALYZER_RUN_START = gql`
  mutation RecordAnalyzerRunStart($input: AnalyzerRunStartInput!) {
    response: recordAnalyzerRunStart(input: $input) {
      ${GENERIC_MUTATION_RESPONSE_FIELDS}
    }
  }
`;

export const GQL_RECORD_ANALYZER_RUN_TURN = gql`
  mutation RecordAnalyzerRunTurn($input: AnalyzerRunTurnInput!) {
    response: recordAnalyzerRunTurn(input: $input) {
      ${GENERIC_MUTATION_RESPONSE_FIELDS}
    }
  }
`;

export const GQL_RECORD_ANALYZER_RUN_FAILURE = gql`
  mutation RecordAnalyzerRunFailure($input: AnalyzerRunFailureInput!) {
    response: recordAnalyzerRunFailure(input: $input) {
      ${GENERIC_MUTATION_RESPONSE_FIELDS}
    }
  }
`;
